// extracted by mini-css-extract-plugin
export default {"c-icon":"opinion-leader-submission_component_c-icon__hSRG3"};